
import React, { useState } from 'react';
import { useFormContext } from "react-hook-form";
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { CalendarDaysIcon, PlusIcon } from 'lucide-react';

interface EventRoom {
  id: number;
}

interface EventRoomSectionProps {
  readOnly?: boolean;
}

const EventRoomSection = ({ readOnly = false }: EventRoomSectionProps) => {
  const { register, setValue, watch } = useFormContext();
  const eventRoom = watch('services.eventRoom', false);
  
  // State for event rooms
  const [eventRooms, setEventRooms] = useState<EventRoom[]>([{ id: 1 }]);

  const handleAddEventRoom = () => {
    if (!readOnly) {
      setEventRooms([...eventRooms, { id: eventRooms.length + 1 }]);
    }
  };

  return (
    <div className="form-group">
      <div className="flex flex-col space-y-2">
        <Label className="form-label flex items-center gap-2">
          <CalendarDaysIcon size={16} />
          Salón de eventos
        </Label>
        <div className="flex items-center space-x-2 mb-2">
          <Switch
            checked={eventRoom}
            onCheckedChange={(checked) => !readOnly && setValue('services.eventRoom', checked)}
            disabled={readOnly}
          />
          <span>{eventRoom ? 'Sí' : 'No'}</span>
        </div>
        
        {eventRoom && (
          <div className="space-y-4 pl-0 pt-4">
            {eventRooms.map((room, index) => (
              <div key={room.id} className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                <div className="form-group">
                  <Label className="form-label">Nombre del Salon</Label>
                  <Input 
                    className="form-input"
                    type="text"
                    min="1"
                    placeholder="Nombre del salón"
                    disabled={readOnly}
                  />
                </div>
                <div className="form-group">
                  <Label className="form-label">Capacidad del salón (personas)</Label>
                  <Input 
                    {...register(`services.eventRoomCapacity.${index}`)}
                    className="form-input"
                    type="number"
                    min="1"
                    disabled={readOnly}
                  />
                </div>
              </div>
            ))}
            
            {!readOnly && (
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={handleAddEventRoom}
                className="mt-2"
              >
                <PlusIcon className="h-4 w-4 mr-1" />
                Agregar
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EventRoomSection;
